import React from 'react';

import { useDismissable } from 'app/developer-v3/hooks';

import PromotionDone from './PromotionDone';

type Props = {
  persistId?: string;
  version: string;
};

function DismissablePromotionDone(props: Props) {
  const { persistId, version } = props;

  const { dismiss, isVisible } = useDismissable({ persistId });

  return isVisible && <PromotionDone onDismiss={dismiss} version={version} />;
}

export default DismissablePromotionDone;
